import Component from '../abstracts/Component';

export default class MyAccountLayerComponent extends Component {
  get SELECTORS() {
    return {
      pwdRecoveryBtn: '[data-pwd-recovery-btn]',
      recoveryPasswordLayer: '[data-password-recovery]',
      recoveryPasswordContainer: '[data-password-container]',
      registerLayer: '[data-register-user]',
      loginForm:'[data-login-form]',
      showLoginBtn: '[data-show-login-btn]',
      recoveryPasswordForm: '#recoveryPwdForm',
      recoveryPasswordFormButton: '#recoveryPwdForm .custom-button',
      recoveryPasswordFormInput: '#recoveryPwdForm input[type="email"]',
      responseSuccess: '[data-mail-sent="true"]',
      responseFail: '[data-mail-sent="false"] .form-input'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      pwdRecoveryBtn: this.$component.querySelector(this.SELECTORS.pwdRecoveryBtn),
      recoveryPasswordLayer: this.$component.querySelector(this.SELECTORS.recoveryPasswordLayer),
      recoveryPasswordContainer: this.$component.querySelector(this.SELECTORS.recoveryPasswordContainer),
      registerLayer: this.$component.querySelector(this.SELECTORS.registerLayer),
      loginForm: this.$component.querySelector(this.SELECTORS.loginForm),
      showLoginBtn: this.$component.querySelector(this.SELECTORS.showLoginBtn),
      recoveryPasswordForm: this.$component.querySelector(this.SELECTORS.recoveryPasswordForm),
      recoveryPasswordFormButton: this.$component.querySelector(this.SELECTORS.recoveryPasswordFormButton),
      recoveryPasswordFormInput: this.$component.querySelector(this.SELECTORS.recoveryPasswordFormInput)
    }
  }

  // PASSWORD RESET FORM HANDLING //
  toggleResetPasswordForm() {
    this.dom.recoveryPasswordLayer.classList.toggle("hidden");
    this.dom.registerLayer.classList.toggle("hidden");
    this.dom.loginForm.classList.toggle("hidden");
  }

  recoverPassword(event) {
    const ctx = this;

    event.preventDefault();
    const url = this.dom.recoveryPasswordForm.getAttribute('action');
    const form = new URLSearchParams(new FormData(this.dom.recoveryPasswordForm));

    ctx.manageSendFromLayer(true, true);
    ctx.readDOM().recoveryPasswordFormButton.classList.add('--loading');

    fetch(url, {
      method: 'POST',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: form
    })
    .then( res => {
      if(res.ok) {
        console.log(res);
        res.text().then(text => {
          const response = new DOMParser().parseFromString(text, 'text/html');
          // put response in page
          const responseSuccess = response.querySelector(ctx.SELECTORS.responseSuccess);
          const responseFail = response.querySelector(ctx.SELECTORS.responseFail);
          if ( responseSuccess != null ) {
            // replace html
            ctx.readDOM().recoveryPasswordContainer.innerHTML = responseSuccess.innerHTML;
            // close layer on timer
            setTimeout(function(){
              ctx.manageSendFromLayer(false , false);
              ctx.toggleResetPasswordForm();
            },3000);
          }
          if ( responseFail != null ) {
            // replace html input
            const layerInput = ctx.readDOM().recoveryPasswordForm.querySelector('.form-input');
            ctx.readDOM().recoveryPasswordForm.replaceChild(responseFail, layerInput);
            // stop loading
            ctx.readDOM().recoveryPasswordFormButton.classList.remove('--loading');
            // open layer, remove forced
            ctx.manageSendFromLayer(false, true);
          }
        })
      }
      else {
        console.error(res);
        ctx.manageSendFromLayer(false, true);
        ctx.readDOM().recoveryPasswordFormButton.classList.remove('--loading');
      }
    })
    .catch(error => this.warn(error));
  }

  manageSendFromLayer(forceShow = false, focus = false) {
    forceShow ? this.$component.classList.add('--sending') : this.$component.classList.remove('--sending');

    if (this.readDOM().recoveryPasswordFormInput) {
      focus ? this.readDOM().recoveryPasswordFormInput.focus() : this.readDOM().recoveryPasswordFormInput.blur();
    }
  }

  // --------------------------- //

  bindEvents() {
    if(this.dom.pwdRecoveryBtn) {
      this.dom.pwdRecoveryBtn.addEventListener("click", () => this.toggleResetPasswordForm());
    }
    if(this.dom.showLoginBtn) {
      this.dom.showLoginBtn.addEventListener("click", () => this.toggleResetPasswordForm());
    }
    if(this.dom.recoveryPasswordForm) {
      this.dom.recoveryPasswordForm.addEventListener("submit", (event) => this.recoverPassword(event));
    }
  }

  render() {
    this.log('rendering...');
    super.render();
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
